var _slicedToArray = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var SunCalc = require('../../utils/suncalc.js');
var BuildingShadows = /*#__PURE__*/function () {
  "use strict";

  function BuildingShadows(options, threebox) {
    _classCallCheck(this, BuildingShadows);
    this.id = options.layerId;
    this.type = 'custom';
    this.renderingMode = '3d';
    this.opacity = 0.5;
    this.buildingsLayerId = options.buildingsLayerId;
    this.minAltitude = options.minAltitude || 0.10;
    this.tb = threebox;
  }
  _createClass(BuildingShadows, [{
    key: "onAdd",
    value: function onAdd(map, gl) {
      this.map = map;
      var vertexSource = "\n\t\t\tuniform mat4 u_matrix;\n\t\t\tuniform float u_height_factor;\n\t\t\tuniform float u_altitude;\n\t\t\tuniform float u_azimuth;\n\t\t\tattribute vec2 a_pos;\n\t\t\tattribute vec4 a_normal_ed;\n\t\t\tattribute lowp vec2 a_base;\n\t\t\tattribute lowp vec2 a_height;\n\t\t\tvoid main() {\n\t\t\t\tfloat base = max(0.0, a_base.x);\n\t\t\t\tfloat height = max(0.0, a_height.x);\n\t\t\t\tfloat t = mod(a_normal_ed.x, 2.0);\n\t\t\t\tvec4 pos = vec4(a_pos, t > 0.0 ? height : base, 1);\n\t\t\t\tfloat len = pos.z * u_height_factor / tan(u_altitude);\n\t\t\t\tpos.x += cos(u_azimuth) * len;\n\t\t\t\tpos.y += sin(u_azimuth) * len;\n\t\t\t\tpos.z = 0.0;\n\t\t\t\tgl_Position = u_matrix * pos;\n\t\t\t}\n\t\t\t";
      var fragmentSource = "\n\t\t\tvoid main() {\n\t\t\t\tgl_FragColor = vec4(0.0, 0.0, 0.0, 0.7);\n\t\t\t}\n\t\t\t";
      var vertexShader = gl.createShader(gl.VERTEX_SHADER);
      gl.shaderSource(vertexShader, vertexSource);
      gl.compileShader(vertexShader);
      var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
      gl.shaderSource(fragmentShader, fragmentSource);
      gl.compileShader(fragmentShader);
      this.program = gl.createProgram();
      gl.attachShader(this.program, vertexShader);
      gl.attachShader(this.program, fragmentShader);
      gl.linkProgram(this.program);
      gl.validateProgram(this.program);
      this.uMatrix = gl.getUniformLocation(this.program, "u_matrix");
      this.uHeightFactor = gl.getUniformLocation(this.program, "u_height_factor");
      this.uAltitude = gl.getUniformLocation(this.program, "u_altitude");
      this.uAzimuth = gl.getUniformLocation(this.program, "u_azimuth");
      this.aPos = gl.getAttribLocation(this.program, "a_pos");
      this.aNormal = gl.getAttribLocation(this.program, "a_normal_ed");
      this.aBase = gl.getAttribLocation(this.program, "a_base");
      this.aHeight = gl.getAttribLocation(this.program, "a_height");
    }
  }, {
    key: "render",
    value: function render(gl, matrix) {
      gl.useProgram(this.program);
      var source = this.map.style.sourceCaches['composite'];
      var coords = source.getVisibleCoordinates().reverse();
      var buildingsLayer = this.map.getLayer(this.buildingsLayerId);
      var context = this.map.painter.context;
      var _this$map$getCenter = this.map.getCenter(),
        lng = _this$map$getCenter.lng,
        lat = _this$map$getCenter.lat;
      var pos = this.tb.getSunPosition(this.tb.lightDateTime, [lng, lat]);
      gl.uniform1f(this.uAltitude, pos.altitude > this.minAltitude ? pos.altitude : 0);
      gl.uniform1f(this.uAzimuth, pos.azimuth + 3 * Math.PI / 2);
      //this.opacity = Math.sin(Math.max(pos.altitude, 0)) * 0.6;
      gl.enable(gl.BLEND);
      //gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.DST_ALPHA, gl.SRC_ALPHA);
      gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
      var ext = gl.getExtension('EXT_blend_minmax');
      //gl.blendEquationSeparate(gl.FUNC_SUBTRACT, ext.MIN_EXT);
      //gl.blendEquation(gl.FUNC_ADD);
      gl.disable(gl.DEPTH_TEST);
      var _iterator = _createForOfIteratorHelper(coords),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var coord = _step.value;
          var tile = source.getTile(coord);
          var bucket = tile.getBucket(buildingsLayer);
          if (!bucket) continue;
          var _bucket$programConfig = _slicedToArray(bucket.programConfigurations.programConfigurations[this.buildingsLayerId]._buffers, 2),
            heightBuffer = _bucket$programConfig[0],
            baseBuffer = _bucket$programConfig[1];
          gl.uniformMatrix4fv(this.uMatrix, false, coord.posMatrix);
          gl.uniform1f(this.uHeightFactor, Math.pow(2, coord.overscaledZ) / tile.tileSize / 8);
          var _iterator2 = _createForOfIteratorHelper(bucket.segments.get()),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var segment = _step2.value;
              var numPrevAttrib = context.currentNumAttributes || 0;
              var numNextAttrib = 2;
              for (var i = numNextAttrib; i < numPrevAttrib; i++) gl.disableVertexAttribArray(i);
              var vertexOffset = segment.vertexOffset || 0;
              gl.enableVertexAttribArray(this.aPos);
              gl.enableVertexAttribArray(this.aNormal);
              gl.enableVertexAttribArray(this.aHeight);
              gl.enableVertexAttribArray(this.aBase);
              bucket.layoutVertexBuffer.bind();
              gl.vertexAttribPointer(this.aPos, 2, gl.SHORT, false, 12, 12 * vertexOffset);
              gl.vertexAttribPointer(this.aNormal, 4, gl.SHORT, false, 12, 4 + 12 * vertexOffset);
              heightBuffer.bind();
              gl.vertexAttribPointer(this.aHeight, 1, gl.FLOAT, false, 4, 4 * vertexOffset);
              baseBuffer.bind();
              gl.vertexAttribPointer(this.aBase, 1, gl.FLOAT, false, 4, 4 * vertexOffset);
              bucket.indexBuffer.bind();
              context.currentNumAttributes = numNextAttrib;
              gl.drawElements(gl.TRIANGLES, segment.primitiveLength * 3, gl.UNSIGNED_SHORT, segment.primitiveOffset * 3 * 2);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);
  return BuildingShadows;
}();
module.exports = exports = BuildingShadows;